import { Button } from '@authentic/loyalty-pwa/components';
import { TextField, ToggleButton } from '@authentic/loyalty-pwa/components/Form';
import { ErrorIcon } from '@authentic/loyalty-pwa/icons';
import { Box, objectIsEmpty, Typography } from '@authentic/loyalty-pwa/util';
import { colors } from '@authentic/loyalty-pwa/util/variables';
import { createRef, Fragment, FunctionalComponent, h, RefObject } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { Controller, useForm } from 'react-hook-form';
import styled from 'styled-components';
import { Location } from '../components/Location';
import { ReferralIcon } from '../icons/Referral';
import { link } from '@authentic/loyalty-pwa/util';

const FormStyled = styled.form`
  background: #ffffff;
  text-align: left;
`;

const ErrorMessage = styled.div`
  color: ${colors.red};
  margin-bottom: 16px;

  .ico {
    display: inline-block;
    margin-right: 4px;
    vertical-align: middle;
  }
`;

const FormControlStyled = styled.div`
  margin-bottom: 22px;
`;

const ReferralLabel = styled.div`
  line-height: 30px;
`;

const ReferralIconStyled = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 0.5em;
`;

const TermsStyled = styled.div`
  margin: 0 auto;
  max-width: 335px;
  text-align: center;
`;

const InputErrorStyled = styled.div`
	color: ${colors.red};
	font-weight: 500;
	font-size: 10px;
	line-height: 12px;
	min-height: 16px;
`;

export const SignUpTwo: FunctionalComponent<{
  callbackSubmit: (data: any, onlyPersistData: boolean) => void;
  formValues: any;
  customError: any;
  hideFields: string[];
  submitFormAction: boolean;
}> = ({ callbackSubmit, formValues, customError, hideFields, submitFormAction }) => {
  const [haveRefer, setHaveRefer] = useState(false);
  const [previousEmail, setPreviousEmail] = useState(formValues.email);
  const [receiveEmail, setReceiveEmail] = useState((formValues?.receiveEmail === undefined) ? true : formValues.receiveEmail);
  const [receiveTexts, setReceiveTexts] = useState((formValues?.receiveTexts === undefined) ? true : formValues.receiveTexts);
  const [defaultFormValues, setDefaultFormValues] = useState(formValues);
  const [locationErrorMessage, setLocationErrorMessage] = useState('');
  const [genericErrorMessage, setGenericErrorMessage] = useState('');
  console.log('hiding email?', hideFields.includes('email'), hideFields)
  const {
    getValues,
    handleSubmit,
    control,
    setError,
    reset,
    setValue,
    formState: { errors, isDirty, isValid },
  } = useForm({
    mode: 'all',
    defaultValues: {
      firstName: formValues?.firstName,
      lastName: formValues?.lastName,
      email: defaultFormValues?.email,
      mobile: formValues?.mobile,
      haveRefer: defaultFormValues?.haveRefer,
      receiveEmail: receiveEmail,
      receiveTexts: receiveTexts,
      referralCode: defaultFormValues?.referralCode,
      location: defaultFormValues?.location,
      locationLabelValue: defaultFormValues?.locationLabelValue,
    },
  });

  useEffect(() => {
    reset(getValues())
  }, [hideFields])

  useEffect(() => {
    if (document && submitFormAction) {
      callbackSubmit(getValues(), true);
    }
  }, [submitFormAction]);

  useEffect(() => {
    Object.keys(customError).forEach(key => {
      if (key === 'generic')
        setGenericErrorMessage(customError[key])
      else
        setError(key as any, { message: customError[key] }, { shouldFocus: true });
    })
  }, [customError])


  const onSubmit = (data: any) => {
    setHaveRefer(false);
    setLocationErrorMessage('');
    setGenericErrorMessage('');
    if (!data.location) {
      setError('location', { message: customError.location }, { shouldFocus: true });
      setLocationErrorMessage(`Favorite Location can't be blank.`)
      return;
    }

    if (!getValues('haveRefer')) {
      data['referralCode'] = '';
    }

    if (previousEmail === data.email) {
      callbackSubmit(data, false);
    } else {
      setError('email', { message: 'Email does not match.  Return to first screen to change.' }, { shouldFocus: true });
    }
  };

  const onChangeRefer = () => {
    setTimeout(() => {
      setHaveRefer(getValues('haveRefer'));
      setDefaultFormValues((prevState: any) => ({
        ...prevState,
        haveRefer: getValues('haveRefer'),
      }));
    }, 0);
  };

  const onChangeReceiveEmail = () => {
    setTimeout(() => {
      setReceiveEmail(getValues('receiveEmail'));
      setDefaultFormValues((prevState: any) => ({
        ...prevState,
        receiveEmail: getValues('receiveEmail'),
      }));
    }, 0);
  };

  const onChangeReceiveTexts = () => {
    setTimeout(() => {
      setReceiveTexts(getValues('receiveTexts'));
      setDefaultFormValues((prevState: any) => ({
        ...prevState,
        receiveTexts: getValues('receiveTexts'),
      }));
    }, 0);
  };

  const onSelectLocation = (data: any) => {
    setValue('location', data?.integration_id);
    setValue('locationLabelValue', data?.labelValue);
  };

  return (
    <FormStyled onSubmit={handleSubmit(onSubmit)} >
      <Typography variant="headline3">Do you have a favorite location? *</Typography>
      <FormControlStyled>
        <Location name="location" callback={onSelectLocation} defaultLabelValue={defaultFormValues?.locationLabelValue} />
        <InputErrorStyled>{locationErrorMessage && <span role="alert">{locationErrorMessage}</span>} </InputErrorStyled>
      </FormControlStyled>
      {!hideFields.includes('name') && (
        <FormControlStyled>
          <Controller
            render={({ field }: any): any => (
              <TextField
                error={errors?.firstName}
                label="First Name"
                required
                {...field}
                id="firstName"
              />
            )}
            rules={{
              required: {
                value: true,
                message: 'Please enter your First Name',
              },
            }}
            control={control}
            name="firstName"
            defaultValue=""
          />
        </FormControlStyled>
      )}
      {!hideFields.includes('name') && (
        <FormControlStyled>
          <Controller
            render={({ field }: any): any => (
              <TextField
                error={errors?.lastName}
                label="Last Name"
                {...field}
                required
                id="lastName"
              />
            )}
            rules={{
              required: {
                value: true,
                message: 'Please enter your Last Name',
              },
            }}
            control={control}
            name="lastName"
            defaultValue=""
          />
        </FormControlStyled>
      )}
      {!hideFields.includes('mobile_phone') && (
        <FormControlStyled>
          <Controller
            render={({ field }: any): any => (
              <TextField
                error={errors?.mobile}
                mask="(999) 999-9999"
                maskPlaceholder="(   )    -    "
                label="Mobile"
                type="tel"
                required
                {...field}
                id="mobile"
              />
            )}
            rules={{
              required: {
                value: true,
                message: 'Please enter your mobile',
              },
            }}
            control={control}
            name="mobile"
            defaultValue=""
          />
        </FormControlStyled>
      )}
      <FormControlStyled>
        <Controller
          render={({ field }: any): any => (
            <ToggleButton
              error={errors?.haveRefer}
              label="Referral Code"
              callback={onChangeRefer}
              checked={defaultFormValues.haveRefer}
              {...field}
              id="haveRefer"
            >
              <ReferralLabel>
                <Typography variant="body1" weight="bold">
                  <ReferralIconStyled>
                    <ReferralIcon />
                  </ReferralIconStyled>
                  Have a refer a friend code?
                </Typography>
              </ReferralLabel>
            </ToggleButton>
          )}
          control={control}
          name="haveRefer"
          defaultValue={haveRefer}
        />
      </FormControlStyled>

      {defaultFormValues.haveRefer && (
        <Fragment>
          <FormControlStyled>
            <Typography variant="body1">
              Del Yeah! Please enter your referral code below.
            </Typography>
          </FormControlStyled>

          <FormControlStyled>
            <Controller
              render={({ field }: any): any => (
                <TextField
                  error={errors?.referralCode}
                  label="Referral Code"
                  required
                  {...field}
                  id="referralCode"
                />
              )}
              control={control}
              name="referralCode"
              defaultValue=""
            />
          </FormControlStyled>
        </Fragment>
      )}

      <FormControlStyled>
        <Typography variant="headline3">How would you like to hear from us?</Typography>
      </FormControlStyled>

      {!hideFields.includes('email') && (
        <FormControlStyled>
          <Controller
            render={({ field }: any): any => (
              <TextField error={errors?.email} label="Confirm Email" {...field} required id="email" />
            )}
            rules={{
              required: {
                value: true,
                message: 'Please enter your Email',
              },
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: 'Entered value does not match email format',
              },
            }}
            control={control}
            name="email"
            defaultValue=""
          />
        </FormControlStyled>
      )}

      <FormControlStyled>
        <Controller
          render={({ field }: any): any => (
            <ToggleButton
              error={errors?.receiveEmail}
              label="Receive emails from Del Taco"
              required
              callback={onChangeReceiveEmail}
              checked={receiveEmail}
              {...field}
              id="receiveEmail"
            >
              <Typography variant="body1">Receive emails from Del Taco</Typography>
            </ToggleButton>
          )}
          control={control}
          name="receiveEmail"
          defaultValue={receiveEmail}
        />
      </FormControlStyled>

      <FormControlStyled>
        <Controller
          render={({ field }: any): any => (
            <ToggleButton
              error={errors?.receiveTexts}
              label="Receive emails from Del Taco"
              required
              callback={onChangeReceiveTexts}
              checked={receiveTexts}
              {...field}
              id="receiveTexts"
            >
              <div>
                <Box mb={8}>
                  <Typography variant="body1">Receive texts from Del Taco</Typography>
                </Box>
                <Typography variant="body3">
                  Message and data rates may apply. <br /> Recurring messages will be sent.
                </Typography>
              </div>
            </ToggleButton>
          )}
          control={control}
          name="receiveTexts"
          defaultValue={receiveTexts}
        />
      </FormControlStyled>

      {!objectIsEmpty(errors) && (
        <ErrorMessage>
          <Typography variant="body1" weight="bold">
            <div className="ico">
              <ErrorIcon />
            </div>
            Review highlighted errors to continue
          </Typography>
        </ErrorMessage>
      )}

      {genericErrorMessage && (
        <ErrorMessage>
          <Typography variant="body1" weight="bold">
            <div className="ico">
              <ErrorIcon />
            </div>
            {genericErrorMessage}
          </Typography>
        </ErrorMessage>
      )}

      <Box mb={20}>
        <Button ariaLabel="NEXT" type="submit" disabled={!isValid} fullWidth>
          SUBMIT
        </Button>
      </Box>

      <TermsStyled>
        <Typography variant="body3">
          By clicking submit you agree to the{' '}
          <a
            href={link('/terms')}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms & Conditions
          </a>
          ,&nbsp;
          <a href={link('/privacy')} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          , and agree to receive marketing communications from Del Taco.
        </Typography>
      </TermsStyled>
    </FormStyled>
  );
};
